import {
  FALLBACK_ERROR_MESSAGE,
  INVALID_INPUT_MESSAGE,
  INVALID_RECAPTCHA_MESSAGE,
  SUPPORT_CONTACT_LINK,
  SUPPORT_EMAIL_MAIL_TO,
} from "@/constants"

export const errors = {
  FAILED_TO_FETCH: {
    title: "We were unable to submit your request",
    message: "Please try again, or contact us if the problem persists.",
    links: [SUPPORT_CONTACT_LINK],
  },
  INVALID_LICENSE_CODE: {
    title: `Invalid license code`,
    message: `This license code was not recognised. Please check and try again.`,
    links: [{ label: `Contact us`, href: SUPPORT_EMAIL_MAIL_TO }],
  },
  LICENSE_CODE_EXPIRED: {
    title: `License code expired`,
    message: `This license code has now expired. Get in touch with your administrator or contact us.`,
    links: [{ label: `Contact us`, href: SUPPORT_EMAIL_MAIL_TO }],
  },
  LICENSE_CODE_REVOKED: {
    title: `License code revoked`,
    message: `This license code is revoked. Get in touch with your administrator or contact us.`,
    links: [{ label: `Contact us`, href: SUPPORT_EMAIL_MAIL_TO }],
  },
  LICENSE_CODE_IN_USE: {
    title: `License code already in use`,
    message: `License code is already associated with another account.`,
    links: [{ label: `Contact us`, href: SUPPORT_EMAIL_MAIL_TO }],
  },
  EMAIL_IN_USE: {
    title: `Email address already in use`,
    message: `Email address is already associated with another account.`,
    links: [
      { label: `Sign in`, href: `/sign-in` },
      { label: `Contact us`, href: SUPPORT_EMAIL_MAIL_TO },
    ],
  },
  CAPTCHA_FAILED: {
    title: `reCAPTCHA failed`,
    message: `We were unable to validate your request. Please refresh your browser and try again`,
    links: [{ label: `Contact us`, href: SUPPORT_EMAIL_MAIL_TO }],
  },
  INVALID_RECAPTCHA: INVALID_RECAPTCHA_MESSAGE,
  INVALID_INPUT: INVALID_INPUT_MESSAGE,
  FALLBACK_ERROR: FALLBACK_ERROR_MESSAGE,
}
